module.exports = __webpack_public_path__ + "img/icn_slider_box_count.734c5a55.svg";